export default "__VITE_ASSET__4Dc8z$TH__"